(() => {
  document.documentElement.classList.add('slt-js');

  const mobileMenuSelector = '.slt-mobile-nav';
  const revealSelector = '[data-slt-reveal]';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const revealObserver = !reducedMotion.matches && 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 })
    : null;

  const initReveals = (scope = document) => {
    const elements = [];
    if (scope instanceof Element && scope.matches(revealSelector)) elements.push(scope);
    scope.querySelectorAll?.(revealSelector).forEach((element) => elements.push(element));

    elements.forEach((element) => {
      if (element.classList.contains('is-visible')) return;
      if (revealObserver) revealObserver.observe(element);
      else element.classList.add('is-visible');
    });
  };

  const syncMobileMenu = () => {
    document.querySelectorAll(mobileMenuSelector).forEach((candidate) => {
      const summary = candidate.querySelector(':scope > summary');
      if (summary) summary.setAttribute('aria-expanded', candidate.open ? 'true' : 'false');
    });

    const menu = document.querySelector(`${mobileMenuSelector}[open]`);
    if (!(menu instanceof HTMLDetailsElement)) {
      document.documentElement.classList.remove('slt-menu-open');
      return;
    }

    const header = menu.closest('.slt-header');
    const menuTop = Math.max(0, Math.round(header?.getBoundingClientRect().bottom || 0));
    if (menuTop) menu.style.setProperty('--slt-mobile-menu-top', `${menuTop}px`);
    document.documentElement.classList.add('slt-menu-open');
  };

  const closeOtherMenus = (active) => {
    document.querySelectorAll('.slt-capabilities[open], .slt-mobile-nav[open]').forEach((menu) => {
      if (menu !== active) menu.removeAttribute('open');
    });
    window.requestAnimationFrame(syncMobileMenu);
  };

  document.addEventListener('toggle', (event) => {
    const menu = event.target;
    if (menu instanceof HTMLDetailsElement && menu.open && (menu.matches('.slt-capabilities') || menu.matches('.slt-mobile-nav'))) {
      closeOtherMenus(menu);
    }
    if (menu instanceof HTMLDetailsElement && menu.matches(mobileMenuSelector)) {
      window.requestAnimationFrame(syncMobileMenu);
    }
  }, true);

  document.addEventListener('click', (event) => {
    const mobileLink = event.target.closest('.slt-mobile-nav a');
    if (mobileLink) {
      mobileLink.closest(mobileMenuSelector)?.removeAttribute('open');
      window.requestAnimationFrame(syncMobileMenu);
    } else if (!event.target.closest('.slt-capabilities, .slt-mobile-nav')) {
      closeOtherMenus(null);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeOtherMenus(null);
  });

  window.addEventListener('resize', () => window.requestAnimationFrame(syncMobileMenu), { passive: true });
  document.addEventListener('shopify:section:load', (event) => {
    initReveals(event.target);
    window.requestAnimationFrame(syncMobileMenu);
  });

  initReveals();
  syncMobileMenu();
})();
